window.jQuery = window.$ = require('jquery');
var gsap = require("gsap").gsap;
var ScrollTrigger = require("gsap/dist/ScrollTrigger").ScrollTrigger;
var SplitText = require("./lib/SplitText").SplitText;
var CustomEase = require("./lib/CustomEase.min.js").CustomEase;
var LoadMore = require("./lib/LoadMore");
var menuGlossary = require("./lib/menuGlossary");
var cookieBar = require("./lib/CookieBar");
var searchLot = require("./lib/SearchLot");
gsap.registerPlugin(ScrollTrigger, CustomEase);

var Swiper = require("swiper/bundle").Swiper;
var simpleParallax = require("simple-parallax-js");

// require('parsleyjs');

require('./announcement');
require('./nav');

require('lazysizes');
//add simple support for background images:
document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});

(function (root, $, undefined) {
    "use strict";

    // Setup herb glossary
    // const items = document.querySelectorAll("ul#menu-header-menu-left .menu-item-object-glossary a")
    // const menuWrapper = document.getElementsByClassName(".megamenu-parent-herb-glossary ul")

    // const formattedItems = Array.from(items).forEach(html =>{
    // 		const item = html.innerText
    // 		if (item.includes("<img")){
    // 			const img = item.split("<img")[1]
    // 			html.innerHTML =  "<img" + img
    // 		}
    // 	})

    // (async function(){
    // //add title and content to herg glossary menu
    // const container = document.querySelector(".megamenu-parent-herb-glossary .container")
    // if (container){
    // 	const title = document.createElement("h2")
    // 	const subtitle = document.createElement("span")
    // 	const link = document.createElement("a")
    // 	let href = 'https://blog.organicolivia.com/glossary/aloe-vera/';
    // 	// const href = setAttribute("href", "tests.com");
    // 	title.innerHTML = "Know Your Herbs"
    // 	subtitle.innerHTML = "Just like us humans, herbs have their own personalities, traditions, and wisdom. Nerd out on the plants in our formulas to cultivate a deeper relationship with the allies in your apothecary."
    // 	link.innerHTML = "<a href='"+href+"' class='blog-glossary font-special'>View Full Herb Glossary</a>"
    // 	container.insertBefore(subtitle, container.firstElementChild).setAttribute('class', "sub-title-glossary");
    // 	container.insertBefore(title, container.firstElementChild).setAttribute('class', "title-glossary font-special");
    // 	container.appendChild(link)
    // }
    // }())

    // Page Loader
    // ================================================
    // $(window).on("load", function (e) {
    //     $("#page-loader").fadeOut();
    //     $(".animate-hero").removeClass("animatable");
    // })

    $(function () {
        // Overlay Function
        // to do: make global functions
        // ================================================

        // Product Slider (Homepage)
        // ================================================
        var productSlider = new Swiper(".product-slider", {
            slidesPerView: 2,
            spaceBetween: 32,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: false,
                dragClass: 'swiper-scrollbar-drag',
                hide: false,
                lockClass: 'swiper-scrollbar-lock',
                snapOnRelease: true
            },
            on: {
                touchStart: function () {
                    $(".product-slider").addClass("mousedown");
                },
                touchEnd: function () {
                    $(".product-slider").removeClass("mousedown");
                }
            },
            breakpoints: {
                992: {
                    slidesPerView: 4
                }
            }
        });


        // Animations (Global)
        // ================================================

        // CustomEase.create("CustomCubic", "0.19,1,0.22,1");
        // new SplitText("h1:not(.no-anim)", { type: "words" });
        // new SplitText("h2:not(.no-anim)", { type: "words" });
        // new SplitText("h3:not(.no-anim)", { type: "words" });
        // new SplitText("h4:not(.no-anim)", { type: "words" });
        // new SplitText("p:not(.no-anim)", { type: "words" });
        // var tl = new gsap.timeline();
        // tl.staggerFrom($("p > div"),
        // 	1, { y: 10, opacity: 0, ease: "CustomCubic" },
        // 	0.015, "grouped");

        // var section = gsap.utils.toArray('section');
        // section.forEach(function (step, i) {
        // 	ScrollTrigger.create({
        // 		trigger: step,
        // 		// start: $(step).offset().top,
        // 		start: "top top",
        // 		// end: "bottom center",
        // 		end: "bottom center",
        // 		onToggle: function (self) {
        // 			console.log(self.trigger);

        // 		}
        // 	});
        // });

        // If theres no activity for 5 seconds do something
        // var activityTimeout = setTimeout(inActive, 45000);

        // function resetActive(){
        //     clearTimeout(activityTimeout);
        //     activityTimeout = setTimeout(inActive, 45000);
        //     $('.screensaver').fadeOut();
        // }

        // // No activity do something.
        // function inActive(){
        //     $('.screensaver').fadeIn();
        //     gsap.fromTo($('.screensaver .wrapper'), 1.5, {opacity: 0, y: 150}, {opacity: 1, y: 0});
        // }

        // // Check for mousemove, could add other events here such as checking for key presses ect.
        // $(document).bind('mousemove', function(){resetActive()});
        // $(document).bind('touchmove', function(){resetActive()});

        // Scroll Move Accents Mobile
        // ========================================
        // var is_touch_device = ("ontouchstart" in window) || window.DocumentTouch && document instanceof DocumentTouch;
        // $(window).bind('scroll', function (e) {
        //     parallaxScroll();
        // });
        // function parallaxScroll() {
        //     const scrolled = $(window).scrollTop();
        //     if (is_touch_device) {
        //       $('.accent').css('top', (0 - (scrolled * 0.09)) + 'px');
        //   }
        // }

        // Scroll Reveal
        // ========================================
        $(function ($) {
            var doAnimations = function () {
                var offset = $(window).scrollTop() + $(window).height(),
                    $animatables = $('.animatable');

                if ($animatables.length == 0) {
                    $(window).off('scroll', doAnimations);
                }
                $animatables.each(function (i) {
                    var $animatable = $(this);
                    if (($animatable.offset().top + $animatable.height() - 20) < offset) {
                        $animatable.removeClass('animatable').addClass('animate');
                    }
                });
            };
            $(window).on('scroll', doAnimations);
            $(window).trigger('scroll');
        });

        var rafId = null;
        var delay = 200;
        var lTime = 0;
        function scroll() {
            var scrollTop = $(window).scrollTop();
            var height = $(window).height()
            var visibleTop = scrollTop + height;
            $('.reveal').each(function () {
                var $t = $(this);
                if ($t.hasClass('reveal_visible')) { return; }
                var top = $t.offset().top;
                if (top <= visibleTop) {
                    if (top + $t.height() < scrollTop) {
                        $t.removeClass('reveal_pending').addClass('reveal_visible');
                    } else {
                        $t.addClass('reveal_pending');
                        if (!rafId) requestAnimationFrame(reveal);
                    }
                }
            });
        }
        function reveal() {
            rafId = null;
            var now = performance.now();

            if (now - lTime > delay) {
                lTime = now;
                var $ts = $('.reveal_pending');
                $($ts.get(0)).removeClass('reveal_pending').addClass('reveal_visible');
            }
            if ($('.reveal_pending').length >= 1) rafId = requestAnimationFrame(reveal);
        }
        $(scroll);
        $(window).scroll(scroll);

        // Header Mini Cart Toggle
        // ========================================
        $(document).on("click", "#mini-cart-open", function (e) {
            e.preventDefault();
            openMiniCart();

        }).on("click", "#mini-cart-close", function (e) {
            e.preventDefault();
            closeMiniCart();
        });

        $(document.body).on('added_to_cart', function () {
            openMiniCart();
        });

        $(document.body).on('cart_updated', function () {
            openMiniCart();
        });

        function updateQuantityInCart(cart_item_key, qty) {
            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: '/wp-admin/admin-ajax.php',
                data: {
                    action: 'wonder_update_item_from_cart',
                    cart_item_key: cart_item_key,
                    qty: qty,
                },
                success: function (data) {
                    $(document).trigger('added_to_cart');
                }
            });
        }

        $(document).on('change', '.qty', function (e) {
            e.preventDefault();
            var qty = $(this).val();
            var cart_item_key = $(this).closest('.cart-product').attr('data-cart-item-key');
            updateQuantityInCart(cart_item_key, qty);
        });


        // Button
        // ========================================
        var $btn = $('.btn'),
            $btnInk = $btn.find('.btn__ink');

        // set $btnInk diameter
        if (!$btnInk.height() && !$btnInk.width()) {
            var d = Math.max($btn.outerWidth(), $btn.outerHeight());
            $btnInk.css({ height: d, width: d });
        }

        $btn.on('mouseenter', function (e) {
            var $rippler = $(this),
                $ink = $(this).find('.btn__ink');

            $ink.removeClass('btn__ink--active');

            // get coordinates
            var x = e.pageX - $rippler.offset().left - $ink.width() / 2;
            var y = e.pageY - $rippler.offset().top - $ink.height() / 2;

            // set $ink position and add class .animate
            $ink.css({
                top: y + 'px',
                left: x + 'px'
            }).addClass('btn__ink--active');
        }).on('mouseleave', function (e) {
            var $rippler = $(this),
                $ink = $(this).find('.btn__ink');

            // get coordinates
            var x = e.pageX - $rippler.offset().left - $ink.width() / 2;
            var y = e.pageY - $rippler.offset().top - $ink.height() / 2;

            // set $ink position and add class
            $ink.css({
                top: y + 'px',
                left: x + 'px'
            }).removeClass('btn__ink--active');
        });

        // Parallax Image (Global)
        // ================================================
        // new simpleParallax(document.querySelectorAll('.parallax--down'), {
        // 	delay: 0.6,
        // 	transition: "cubic-bezier(0.19,1,0.22,1)",
        // 	scale: 1.10,
        // 	orientation: "down"
        // });

        // Parallax Hero Image (Shop Page)
        // ================================================
        new simpleParallax(document.querySelectorAll('.hero-img'), {
            delay: 0.6,
            transition: "cubic-bezier(0.19,1,0.22,1)",
            orientation: "down",
            overflow: false
        });

        // Shop Page Mobile Filter Toggle
        // ================================================
        $("#product-filter").on("click", function () {
            $(".mobile-product-filter").slideToggle(300);
        });

        // PDP Custom Quantity Buttons
        // ========================================
        if ($(".cart").length) {
            if (!String.prototype.getDecimals) {
                String.prototype.getDecimals = function () {
                    var num = this,
                        match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
                    if (!match) {
                        return 0;
                    }
                    return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
                }
            }
            // Quantity "plus" and "minus" buttons
            $(document.body).on('click', '.plus, .minus', function () {
                var $qty = $(this).closest('.quantity').find('.qty'),
                    currentVal = parseFloat($qty.val()),
                    max = parseFloat($qty.attr('max')),
                    min = parseFloat($qty.attr('min')),
                    step = $qty.attr('step');

                // Format values
                if (!currentVal || currentVal === '' || currentVal === 'NaN') currentVal = 0;
                if (max === '' || max === 'NaN') max = '';
                if (min === '' || min === 'NaN') min = 0;
                if (step === 'any' || step === '' || step === undefined || parseFloat(step) === 'NaN') step = 1;

                // Change the value
                if ($(this).is('.plus')) {
                    if (max && (currentVal >= max)) {
                        $qty.val(max);
                    } else {
                        $qty.val((currentVal + parseFloat(step)).toFixed(step.getDecimals()));
                    }
                } else {
                    if (min && (currentVal <= min)) {
                        $qty.val(min);
                    } else if (currentVal > 0) {
                        $qty.val((currentVal - parseFloat(step)).toFixed(step.getDecimals()));
                    }
                }

                // Trigger change event
                $qty.trigger('change');
            });
        }


        // Our Quality Harvest
        // ========================================
        $('.inline-dropdown__current').on('click', function (e) {
            e.stopPropagation();
            $('.inline-dropdown__options').hide();
            $(this).next().show();
            $(this).parent().addClass('open');
        });

        $('.inline-dropdown__option').on('click', function (e) {
            e.stopPropagation();
            $('.inline-dropdown__options').hide();
            const index = $(this).attr('data-index')
            const options = $(this).closest('.tip__headline').next();
            console.log(options);

            $('.inline-dropdown').removeClass('open');


            // Changes selected value text
            $(this).parent().prev().text($(this).text());
            $('.inline-dropdown__option').removeClass('selected');
            $(this).addClass('selected');

            // Hides other options + shows relevant one
            options.children().hide();
            options.children().eq(index).show();

            $(this).parent().prepend($(this));
        });

        $(document).click(function (e) {
            $('.inline-dropdown').removeClass('open');
            $('.inline-dropdown__options').hide();
        })

        // Possible mobile option
        // $('.inline-select').on('change', function () {
        // 	const options = $(this).parent().parent().parent().find('.tip__options');

        // 	options.children().hide();
        // 	console.log($(this).val());
        // 	console.log(options.children().find(`[data-index='${$(this).val()}'`));
        // 	options.children().eq($(this).val()).show();
        // 	// console.log(options.find(`[data-index="${$(this).val()}"]`));
        // });

        // Our Quality Know Your Herbs Slider
        // ========================================
        if ($(".card").length) {
            var pdpKnowYourHerbsSlider = new Swiper(".card-slider", {
                slidesPerView: 1.5,
                spaceBetween: 32,
                noSwiping: true,
                loop: true,
                draggable: false,
                allowTouchMove: false,
                autoplay: {
                    delay: 1,
                    disableOnInteraction: false,
                },
                freeMode: true,
                speed: 4000,
                freeModeMomentum: false,
                on: {
                    touchStart: function () {
                        $(".card-slider").addClass("mousedown");
                    },
                    touchEnd: function () {
                        $(".card-slider").removeClass("mousedown");
                    }
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    992: {
                        slidesPerView: 2.5
                    }
                }
            });
        }

        // Glossary Mobile Nav
        // ========================================
        $("#glossary-pages").on("change", function (e) {
            window.location.href = $(e.target.options[e.target.selectedIndex]).attr("data-href");
        });

        // Glossary Slider
        // ========================================
        if ($("#shop-this-herb-slider").length) {
            var shopThisHerbSlider = new Swiper("#shop-this-herb-slider", {
                slidesPerView: 2,
                spaceBetween: 32,
                on: {
                    touchStart: function () {
                        $(this).addClass("mousedown");
                    },
                    touchEnd: function () {
                        $(this).removeClass("mousedown");
                    }
                },
                breakpoints: {
                    992: {
                        slidesPerView: 3
                    }
                }
            });
        }


        // Custom Comments Toggle Button
        // ========================================
        $(".comments-toggle").on("click", function () {
            $(".comment-respond").slideToggle(300);
        })


        // Social Share
        // ========================================
        var copyToClipboard = function (str) {
            var el = document.createElement('textarea');
            el.value = str;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        };
        $(".social-share a#copy-url").on("click", function (e) {
            e.preventDefault();
            var me = $(this);
            var url = $(this).attr("data-href");
            copyToClipboard(url);
            $(this).siblings(".social-share__tooltip").addClass("active");
            setTimeout(function () {
                me.siblings(".social-share__tooltip").removeClass("active");
            }, 2000);
        });

        $(".share-widget a#copy-url-widget").on("click", function (e) {
            e.preventDefault();
            var me = $(this);
            var url = $(this).attr("data-href");
            copyToClipboard(url);
            $(this).siblings(".social-share__tooltip").addClass("active");
            setTimeout(function () {
                me.siblings(".social-share__tooltip").removeClass("active");
            }, 2000);
        });

        // Custom Podcast Player
        // ========================================
        if ($(".podcast-player").length) {


            // Set token
            const _token = "BQDGV32OaSgzlJWf33xOyTpfXh7-xhpTZyNzM0usx7VvfglyTsFvGKisAuXBKf4q2jDnAk4z48eC9Lp-Yzvd8RHPpDk8hDIAXXoEON_wgqa6zAYFBaM_SohuNuNoR2O1MQiuPN7svjKx1PBZ3xBYOUYKQxpOIJk";

            // Set up the Web Playback SDK

            window.onSpotifyPlayerAPIReady = () => {
                const player = new Spotify.Player({
                    name: 'Web Playback SDK Template',
                    getOAuthToken: cb => { cb(_token); }
                });

                // Error handling
                player.on('initialization_error', e => console.error(e));
                player.on('authentication_error', e => console.error(e));
                player.on('account_error', e => console.error(e));
                player.on('playback_error', e => console.error(e));

                // Playback status updates
                player.on('player_state_changed', state => {
                    console.log(state)
                    // $('#current-track').attr('src', state.track_window.current_track.album.images[0].url);
                    // $('#current-track-name').text(state.track_window.current_track.name);
                });

                // Ready
                player.on('ready', data => {
                    console.log('Ready with Device ID', data.device_id);

                    // Play a track using our new device ID
                    play(data.device_id);
                });

                // Connect to the player!
                player.connect();
            }

            // Play a specified track on the Web Playback SDK's device ID
            function play(device_id) {
                $.ajax({
                    url: "https://api.spotify.com/v1/me/player/play?device_id=" + device_id,
                    type: "PUT",
                    data: '{"uris": ["spotify:track:5ya2gsaIhTkAuWYEMB0nw5"]}',
                    beforeSend: function (xhr) { xhr.setRequestHeader('Authorization', 'Bearer ' + _token); },
                    success: function (data) {
                        console.log(data)
                    }
                });
            }


        }

        // // Checkout nav
        // // ========================================
        // var $form = $('#checkout-form');

        // if ($form.length) {

        // 	var currentFormStep;

        // 	function validateThenGoToStep(step) {
        // 		$form.parsley().whenValidate({
        // 			group: 'block-' + (step - 1)
        // 		}).done(function () {
        // 			showCheckoutStep(step);
        // 		});
        // 	}

        // 	function showCheckoutStep(step) {
        // 		console.log('Step', step);

        // 		$('.checkout-step').removeClass('active');
        // 		$('.checkout-step[data-checkout-step="' + step + '"]').addClass('active');
        // 		// $('.checkout-breadcrumbs-breadcrumb').removeClass('checkout-breadcrumbs-breadcrumb__active');

        // 		for (var i = step + 1; i <= $('.checkout-breadcrumbs-breadcrumb').length - 1; i++) {
        // 			$('.checkout-breadcrumbs-breadcrumb').eq(i).removeClass('checkout-breadcrumbs-breadcrumb__active');
        // 		}

        // 		var $breadcrumb = $('.checkout-breadcrumbs-breadcrumb').eq(step);
        // 		var position = $breadcrumb.position();
        // 		var left = position.left;
        // 		var offset = $breadcrumb.outerWidth(true) / 2;
        // 		$('#checkout-breadcrumbs-progress').css('width', (left + offset) + 'px');

        // 		setTimeout(function () {
        // 			for (var i = 0; i <= step; i++) {
        // 				$('.checkout-breadcrumbs-breadcrumb').eq(i).addClass('checkout-breadcrumbs-breadcrumb__active');
        // 			}
        // 		}, 900);

        // 		$("html, body").animate({ scrollTop: 0 }, "slow");

        // 		currentFormStep = step;

        // 	}

        // 	$('[data-back-button]').on('click', function () {
        // 		var step = $(this).closest('.checkout-step').attr('data-checkout-step');
        // 		console.log('Parent step', step);
        // 		step--;
        // 		if (step < 0) {
        // 			step = 0;
        // 		}
        // 		showCheckoutStep(step);
        // 	});

        // 	$('[data-next-button]').on('click', function () {
        // 		var step = $(this).closest('.checkout-step').attr('data-checkout-step');
        // 		step++;
        // 		validateThenGoToStep(step);
        // 	});

        // 	$('[data-step-select]').on('click', function () {
        // 		var step = $(this).attr('data-checkout-step');
        // 		step--; // This is to offset for zero-based
        // 		if (!step || step < 0) {
        // 			step = 0;
        // 		}
        // 		showCheckoutStep(step);
        // 	});

        // 	$form.parsley();

        // 	// Prepare sections by setting the `data-parsley-group` attribute to 'block-0', 'block-1', etc.
        // 	var $sections = $('.checkout-step');
        // 	$sections.each(function (index, section) {
        // 		$(section).find(':input').attr('data-parsley-group', 'block-' + index);
        // 	});

        // 	$(window).on('resize', function () {
        // 		showCheckoutStep(currentFormStep);
        // 	});

        // 	showCheckoutStep(0);
        // }

        // $( document.body ).on( 'added_to_cart', function( event, fragments, cart_hash, $button ){
        // 	alert('hi');
        // });


    });


    /* BLOG CAROUSEL --------------------------------------------- */
    (function () {
        if (!$('.blog-carousel').length) return;
        $([document.documentElement, document.body]).addClass('no-overflow-x');

        const slider = $('.blog-carousel .slider');
        const btns = $('.blog-carousel .arrows-wrap button');
        const items = $('.blog-carousel .slider .item').each((i, el) => el.dataset.index = i);
        const slideAmount = 100 / items.length;
        const half = items.length / 2;
        let curIndex;
        let curSlideAmount;
        let isSet = false;

        const setCarousel = () => {
            curIndex = 0;
            curSlideAmount = (-slideAmount * Math.floor(half) + 1);
            items.removeClass(['reveal', 'col-lg-4', 'col-6']);
            items.slice(curIndex, 3).addClass('in-focus');
            items[getIndex(curIndex, -1)].classList.add('gradient-left');
            items[getIndex(curIndex, 3)].classList.add('gradient-right');
            items.slice(curIndex, Math.ceil(half)).detach().appendTo('.blog-carousel .slider');
            gsap.set(slider, { xPercent: curSlideAmount });
            btns.on('click', onBtn);
            isSet = true;
        }

        const onBtn = (e) => {
            items.removeClass(['gradient-left', 'gradient-right']);
            if (e.currentTarget.dataset.dir === 'backward') backward();
            else if (e.currentTarget.dataset.dir === 'forward') forward();
            btns.attr('disabled', 'disabled');
        }

        const backward = () => {
            slider.find(`.item[data-index="${get2Ahead()}"]`).removeClass('in-focus');
            curIndex = getIndex(curIndex, -1);
            slider.find(`.item[data-index="${curIndex}"]`).addClass('in-focus');
            curSlideAmount += slideAmount;
            items[getIndex(curIndex, -1)].classList.add('gradient-left');
            items[getIndex(curIndex, 3)].classList.add('gradient-right');
            gsap.to(slider, { duration: 0.5, xPercent: curSlideAmount, ease: 'power2.out', onComplete: () => removeAndAppend(false) });
        }

        const forward = () => {
            slider.find(`.item[data-index="${curIndex}"]`).removeClass('in-focus');
            curIndex = getIndex(curIndex, 1);
            slider.find(`.item[data-index="${get2Ahead()}"]`).addClass('in-focus');
            curSlideAmount -= slideAmount;
            items[getIndex(curIndex, -1)].classList.add('gradient-left');
            items[getIndex(curIndex, 3)].classList.add('gradient-right');
            gsap.to(slider, { duration: 0.5, xPercent: curSlideAmount, ease: 'power2.out', onComplete: () => removeAndAppend() });
        }

        const removeAndAppend = (first = true) => {
            if (first) {
                $('.blog-carousel .slider .item:first-child').detach().appendTo('.blog-carousel .slider');
                curSlideAmount += slideAmount;
            } else {
                $('.blog-carousel .slider .item:last-child').detach().prependTo('.blog-carousel .slider');
                curSlideAmount -= slideAmount;
            }
            gsap.set(slider, { xPercent: curSlideAmount });
            btns.attr('disabled', null);
        }

        const getIndex = (index, amount) => {
            if (index + amount > items.length - 1) {
                return index + amount - items.length;
            } else if (index + amount === -1) {
                return items.length - 1;
            } else {
                return index + amount;
            }
        }

        const get2Ahead = () => {
            if (curIndex + 2 > items.length - 1) {
                return (curIndex + 2) - (items.length);
            } else {
                return curIndex + 2;
            }
        }

        $(window).on('resize', () => {
            if ($(window).width() >= 768) {
                // set carousel
                if (!isSet) setCarousel();
            } else {
                // reset to non-carousel
                if (isSet) {
                    btns.off('click', onBtn);
                    slider.removeAttr('style');
                    items.detach().appendTo('.blog-carousel .slider').removeClass(['filter-left', 'filter-right']);
                    isSet = false;
                }
                items.addClass(['reveal', 'col-lg-4', 'col-6']);
                $(window).scroll();
            }
        });

        $(window).trigger('resize');

        const catTitles = $('.blog-cat-title');
        catTitles.on('click', function () {
            catTitles.removeClass('selected');
            $(this).addClass('selected');
            const index = $(this).data('index');
            $(".blog-categories__item-list--show").removeClass('blog-categories__item-list--show');
            $(`.blog-categories__item-list[data-index='${index}']`).addClass('blog-categories__item-list--show');
        });
    }());
    /* BLOG CAROUSEL END --------------------------------------------- */

    /* PODCAST CAROUSEL --------------------------------------------- */
    (function () {
        if (!$('.podcast-carousel').length) return;

        const slider = $('.podcast-carousel .slider');
        const btns = $('.podcast-carousel .arrows-wrap button');
        const infoDiv = $('.selected-ep-info');
        const searchDiv = $('.podcast-search');
        /* slider.append($($('.podcast-carousel .slider .item')[0]).clone()); */
        const items = $('.podcast-carousel .slider .item').each((i, el) => el.dataset.index = i);
        const slideAmount = 100 / items.length;
        const half = items.length / 2;
        const even = items.length % 2 ? false : true;
        let curIndex = 0;
        let curSlideAmount;
        let isMobile = false;
        let isSet = false;
        let setPlusOne;
        let selectedIndex = -1;

        const setCarousel = () => {
            curSlideAmount = (!even ? 0 : -slideAmount / 2) + (isSet ? (isMobile ? (setPlusOne ? slideAmount : 0) : (setPlusOne ? 0 : -slideAmount)) : 0);
            items.removeClass('in-focus');
            let sliced = items.slice(curIndex, curIndex + (isMobile ? 1 : 3));
            if (!isMobile && sliced.length !== 3) {
                const arr = [items[0]];
                if (sliced.length === 1) arr.push(items[1]);
                sliced = sliced.add(arr);
            }
            sliced.addClass('in-focus');
            //
            if (!isSet) {
                const addOne = isMobile ? 0 : (!even ? 1 : 0)
                items.slice(curIndex, Math.ceil(half + addOne)).detach().appendTo('.podcast-carousel .slider');
                isSet = true;
                setPlusOne = addOne ? true : false;
                btns.on('pointerup', onBtn);
                items.on('pointerup', onItem);
            }
            gsap.set(slider, { xPercent: curSlideAmount });
            //
            if (selectedIndex !== -1 && curIndex !== selectedIndex) {
                if (curIndex - selectedIndex === -1) {
                    forward(false);
                } else if (curIndex - selectedIndex === -2) {
                    forward(false);
                    setTimeout(() => {
                        forward(false);
                    }, 550);
                } else if (curIndex - selectedIndex === 1) {
                    backward(false);
                } else if (curIndex - selectedIndex === 2) {
                    backward(false);
                    setTimeout(() => {
                        backward(false);
                    }, 550);
                }
            }
        }

        const onItem = (e) => {
            selectedIndex = parseInt((e.currentTarget || e).dataset.index);
            items.filter((i) => i != (e.currentTarget || e).dataset.index).removeClass('selected');
            (e.currentTarget || e).classList.toggle('selected');
            if (!(e.currentTarget || e).classList.contains('selected')) selectedIndex = -1;
            showInfo();
        }

        const showInfo = () => {
            if (selectedIndex !== -1) {
                infoDiv.html(items[selectedIndex].firstElementChild.innerHTML);
                infoDiv.addClass('show');
            } else {
                infoDiv.removeClass('show');
            }
        }

        const onBtn = (e) => {
            if (e.currentTarget.dataset.dir === 'backward') backward();
            else if (e.currentTarget.dataset.dir === 'forward') forward();
            btns.attr('disabled', 'disabled');
        }

        const backward = (updateSelected = true) => {
            slider.find(`.item[data-index="${isMobile ? curIndex : get2Ahead()}"]`).removeClass('in-focus');
            curIndex = getIndex(curIndex, -1);
            slider.find(`.item[data-index="${curIndex}"]`).addClass('in-focus');
            if (updateSelected && selectedIndex !== -1) onItem(slider.find(`.item[data-index="${getIndex(selectedIndex, -1)}"]`)[0]);
            gsap.to(slider, { duration: 0.5, xPercent: curSlideAmount + slideAmount, ease: 'power2.out', onComplete: () => removeAndAppend(false) });
        }

        const forward = (updateSelected = true) => {
            slider.find(`.item[data-index="${curIndex}"]`).removeClass('in-focus');
            curIndex = getIndex(curIndex, 1);
            slider.find(`.item[data-index="${isMobile ? curIndex : get2Ahead()}"]`).addClass('in-focus');
            if (updateSelected && selectedIndex !== -1) onItem(slider.find(`.item[data-index="${getIndex(selectedIndex, 1)}"]`)[0]);
            gsap.to(slider, { duration: 0.5, xPercent: curSlideAmount - slideAmount, ease: 'power2.out', onComplete: () => removeAndAppend() });
        }

        const removeAndAppend = (first = true) => {
            if (first) {
                $('.podcast-carousel .slider .item:first-child').detach().appendTo('.podcast-carousel .slider');
            } else {
                $('.podcast-carousel .slider .item:last-child').detach().prependTo('.podcast-carousel .slider');
            }
            gsap.set(slider, { xPercent: curSlideAmount });
            btns.attr('disabled', null);
        }

        const getIndex = (index, amount) => {
            if (index + amount > items.length - 1) {
                return 0;
            } else if (index + amount < 0) {
                return items.length - 1;
            } else {
                return index + amount;
            }
        }

        const get2Ahead = () => {
            if (curIndex + 2 > items.length - 1) {
                return (curIndex + 2) - (items.length);
            } else {
                return curIndex + 2;
            }
        }

        $(window).on('resize', () => {
            isMobile = $(window).width() < 768;
            setCarousel();
        });

        $(window).trigger('resize');
    }());
    /* PODCAST CAROUSEL END --------------------------------------------- */

    /* PODCAST TITLE HOVER --------------------------------------------- */
    (function () {
        if (!$('.podcast-img-title-wrap').length) return;

        const items = $('li.podcast-rule');
        const sideImage = $('.podcast-sticky-img');
        const mainImage = $('.podcast-sticky-img picture');

        function onMouseEnter() {
            mainImage.detach();
            sideImage.css('background-image', $(this).find('.img-bg').css('background-image'));
        }

        function onMouseLeave() {
            sideImage.append(mainImage).css('background-image', null);
        }

        items.on('mouseenter', onMouseEnter);
        items.on('mouseleave', onMouseLeave);

    }());
    /* PODCAST TITLE HOVER END --------------------------------------------- */
    window.onRecipePrint = () => {
        $('header, footer, p, .hide-on-recipe-print-only').addClass('hide-on-recipe-print');
        $('.recipe-card').addClass('on-print');
        window.print();
        $('header, footer, p, .hide-on-recipe-print-only').removeClass('hide-on-recipe-print');
        $('.recipe-card').removeClass('on-print');
    }

}(this, jQuery));
